import React, { useEffect, useState } from 'react';
import { Checkbox, DisplayText } from '@superops/ui-design-system';

// THIS COMPONENT IS USED TO RENDER
//  CUSTOM FIELD - CHECKBOX

const CustomCheckBox = (props) => {
  const { field, value, onChange, isDisabled } = props;
  const { fieldType, label } = field;

  const [currentValue, setCurrentValue] = useState(value || null);

  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const fldOptions = field?.options || field?.fieldOptions;
  const options = fldOptions?.map((option) => ({
    value: option?.value,
    label: option?.value
  }));

  const updateValue = (val) => {
    // setCurrentValue(val);
    if (val?.value) {
      setCurrentValue((prevState) => [...(prevState || []), val?.label]);
    } else {
      const updatedValue = currentValueByRef.current.filter(
        (el) => el !== val?.label
      );
      setCurrentValue(updatedValue);
    }
    if (onChange && typeof onChange === 'function') {
      onChange(field, val);
    }
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  //   Value should be as props
  //   We get fields from the get fields API but the selected values wont be availabe
  //   Selected values should an array of strings ['Choice 1'] and this will be passed to checked prop

  return (
    <>
      <div className="fields-wrapper">
        <DisplayText size="extraLarge" weight="Medium">
          {label}
        </DisplayText>
        <div className="custom-field-input">
          {options.map((option, idx) => {
            return (
              <div className="mb10" key={idx}>
                <Checkbox
                  checked={
                    currentValueByRef.current &&
                    currentValueByRef.current.some((el) => el === option?.label)
                  }
                  label={option?.label}
                  onChange={(val) =>
                    updateValue({ label: option?.label, value: val })
                  }
                  disabled={isDisabled}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CustomCheckBox;
